export const HEADER_NAV_ITEMS = [
  { label: '首页', anchor: '#hero' },
  { label: '精选推荐', anchor: '#cards' },
  { label: '平台优势', anchor: '#features' },
  { label: '热门专题', anchor: '#carousel' },
  { label: '热门标签', anchor: '#topics' },
  { label: '常见问题', anchor: '#faq' },
  { label: '联系我们', anchor: '#contact' },
];

export const FAQ_ITEMS = [
  {
    question: '555电影网的影片需要下载才能观看吗？',
    answer: '不需要。555电影网所有影片均支持在线高清播放，无需下载任何播放器或视频文件，点击即可秒播，真正做到全集电影不缓冲在线看，让您享受流畅的观影体验。',
  },
  {
    question: '555电影网的画质怎么样？支持高清吗？',
    answer: '555电影网提供多档画质选择，包括超清1080P、高清720P和流畅480P，您可以根据网络状况自由切换。我们持续优化片源质量，确保每一部电影都以最佳画质呈现。',
  },
  {
    question: '555电影网更新频率如何？能看到最新大片吗？',
    answer: '555电影网每日更新，片库覆盖最新院线大片、热门影视剧和经典老片。我们的内容团队7×24小时持续更新片源，确保您在第一时间观看到最新上线的电影作品。',
  },
  {
    question: '在555电影网观看电影需要注册或付费吗？',
    answer: '完全不需要。555电影网所有内容均为免费提供，无需注册账号，无需支付任何费用。打开网站即可畅享海量高清电影资源，真正做到零门槛免费在线观看。',
  },
];

export const FEATURES_ITEMS = [
  {
    icon: 'ri-flashlight-line',
    title: '秒播不缓冲',
    description: '采用全球CDN加速节点，智能匹配最优线路，实现电影秒加载、零等待的流畅播放体验，告别卡顿与缓冲。',
  },
  {
    icon: 'ri-movie-2-line',
    title: '海量片库覆盖',
    description: '收录超过十万部电影资源，涵盖动作、喜剧、爱情、科幻、恐怖等全品类，从院线新片到经典老片一应俱全。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    description: '555电影网承诺绿色观影环境，无弹窗广告、无恶意跳转、无强制安装，纯净播放页面让您安心享受每一部电影。',
  },
];

export const ABOUT_CONTENT = {
  title: '关于555电影网',
  paragraphs: [
    '555电影网成立于2018年，是国内领先的免费高清电影在线观看平台。我们致力于为广大影迷提供最新、最全、最高清的电影资源，让每一位用户都能在这里找到心仪的影视作品，享受极致的在线观影体验。',
    '经过多年发展，555电影网已建立起覆盖全球的CDN加速网络，确保无论您身处何地，都能获得秒播不缓冲的流畅观影体验。我们的内容团队持续追踪全球影视动态，每日更新最新片源，让555电影始终走在行业前沿。',
  ],
  stats: [
    { value: '100,000+', label: '影片资源' },
    { value: '5,000万+', label: '月活用户' },
    { value: '99.9%', label: '播放成功率' },
  ],
};

export const MEDIA_ITEMS = [
  {
    title: '动作大片专区',
    description: '集结全球顶尖动作电影，高燃打斗场面一触即发',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20cinematic%20scene%20with%20dramatic%20warm%20lighting%2C%20golden%20and%20amber%20tones%2C%20abstract%20film%20texture%2C%20soft%20bokeh%20lights%2C%20artistic%20cinema%20aesthetic%2C%20dark%20atmospheric%20background%2C%20elegant%20composition&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '悬疑烧脑剧场',
    description: '高智商反转剧情，每一帧都藏着意想不到的惊喜',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20suspense%20cinematic%20abstract%20art%20with%20deep%20shadows%20and%20warm%20amber%20highlights%2C%20film%20noir%20aesthetic%2C%20soft%20spotlight%20beams%2C%20textured%20dark%20background%2C%20elegant%20minimalist%20composition&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '喜剧欢乐时光',
    description: '精选国内外高分喜剧，让欢笑成为最好的放松方式',
    image: 'https://readdy.ai/api/search-image?query=Bright%20warm%20cinematic%20abstract%20scene%20with%20soft%20golden%20lighting%2C%20playful%20film%20elements%2C%20amber%20and%20cream%20tones%2C%20artistic%20bokeh%20background%2C%20uplifting%20cinema%20mood%2C%20elegant%20textured%20composition&width=800&height=500&seq=media-03&orientation=landscape',
  },
  {
    title: '科幻视觉盛宴',
    description: '震撼特效与宏大世界观，带你探索无限的想象空间',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20cinematic%20abstract%20composition%20with%20deep%20blue%20and%20warm%20orange%20accents%2C%20cosmic%20atmosphere%2C%20film%20grain%20texture%2C%20soft%20neon%20glow%2C%20dark%20elegant%20background%2C%20artistic%20sci-fi%20cinema%20aesthetic&width=800&height=500&seq=media-04&orientation=landscape',
  },
  {
    title: '经典重温之旅',
    description: '豆瓣高分经典老片修复版，重温那些年的光影记忆',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20vintage%20cinema%20abstract%20art%20with%20warm%20sepia%20and%20golden%20tones%2C%20classic%20film%20reel%20silhouette%2C%20soft%20textured%20background%2C%20elegant%20retro%20movie%20aesthetic%2C%20gentle%20spotlight%2C%20timeless%20composition&width=800&height=500&seq=media-05&orientation=landscape',
  },
];

export const UPDATES_ITEMS = [
  { date: '2026-07-31', title: '【新片上线】《时空逆转2》高清版全网首发上线', tag: '新片' },
  { date: '2026-07-30', title: '【片库扩容】本周新增500+高清电影资源，涵盖多语种', tag: '片库' },
  { date: '2026-07-29', title: '【系统升级】CDN节点扩充至全球80+个地区，播放更流畅', tag: '系统' },
  { date: '2026-07-28', title: '【热门推荐】暑期档观影指南专题已更新，精选50部必看大片', tag: '推荐' },
  { date: '2026-07-27', title: '【画质提升】200部经典影片完成4K修复，画质全面升级', tag: '画质' },
  { date: '2026-07-26', title: '【用户突破】555电影网月活跃用户突破5000万，感谢支持', tag: '里程碑' },
  { date: '2026-07-25', title: '【功能上线】智能推荐算法升级，猜你喜欢更精准', tag: '功能' },
  { date: '2026-07-24', title: '【内容合作】与三大版权方达成合作，正版片源持续扩充', tag: '合作' },
];

export const INDEX_ITEMS = [
  { title: '院线新片', description: '最新上映的国内外大片合集', count: '2,300+', icon: 'ri-film-line' },
  { title: '高分经典', description: '豆瓣8分以上经典佳片', count: '8,500+', icon: 'ri-star-line' },
  { title: '动作冒险', description: '高燃动作与惊险冒险', count: '12,000+', icon: 'ri-fire-line' },
  { title: '悬疑推理', description: '烧脑剧情与反转结局', count: '5,800+', icon: 'ri-search-eye-line' },
  { title: '喜剧专区', description: '让你的每一天都充满欢笑', count: '9,200+', icon: 'ri-emotion-laugh-line' },
  { title: '科幻世界', description: '探索宇宙与未来科技', count: '4,600+', icon: 'ri-rocket-line' },
  { title: '爱情文艺', description: '浪漫动人的情感故事', count: '7,300+', icon: 'ri-heart-line' },
];

export const TOPICS_ITEMS = [
  { label: '暑期档', hot: true },
  { label: '国产大片', hot: true },
  { label: '好莱坞', hot: true },
  { label: '动作片', hot: false },
  { label: '科幻片', hot: false },
  { label: '悬疑片', hot: true },
  { label: '喜剧片', hot: false },
  { label: '恐怖片', hot: false },
  { label: '动画电影', hot: false },
  { label: '纪录片', hot: false },
];

export const CAROUSEL_ITEMS = [
  {
    title: '暑期档观影指南',
    description: '炎炎夏日，窝在家里看大片！我们精选了今年暑期最值得期待的50部电影，涵盖动作、科幻、喜剧等多种类型，让你足不出户也能享受影院级观影体验。',
    image: 'https://readdy.ai/api/search-image?query=Summer%20cinema%20abstract%20art%20with%20warm%20golden%20sunset%20tones%2C%20film%20reel%20elements%2C%20soft%20bokeh%20lights%2C%20cinematic%20atmosphere%2C%20dark%20elegant%20background%20with%20amber%20highlights%2C%20artistic%20composition&width=900&height=500&seq=carousel-01&orientation=landscape',
    tag: '专题',
  },
  {
    title: '国产电影崛起之路',
    description: '近年来国产电影质量突飞猛进，从票房黑马到口碑佳作，555电影网整理了近五年最值得回味的国产佳片，见证中国电影的黄金时代。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20cinema%20artistic%20abstract%20composition%20with%20warm%20red%20and%20golden%20tones%2C%20traditional%20and%20modern%20elements%20blend%2C%20soft%20spotlight%2C%20elegant%20dark%20background%2C%20cinematic%20texture%2C%20refined%20aesthetic&width=900&height=500&seq=carousel-02&orientation=landscape',
    tag: '专题',
  },
  {
    title: '经典老片高清修复',
    description: '我们投入大量资源对经典老片进行高清修复，让那些陪伴我们成长的影像记忆以全新画质重新呈现。《霸王别姬》《活着》等200部经典已全部上线。',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20nostalgic%20abstract%20art%20with%20warm%20sepia%20and%20amber%20tones%2C%20classic%20movie%20elements%2C%20soft%20textured%20grain%2C%20elegant%20dark%20background%2C%20timeless%20cinema%20aesthetic%2C%20refined%20composition&width=900&height=500&seq=carousel-03&orientation=landscape',
    tag: '专题',
  },
  {
    title: '全球冷门佳片推荐',
    description: '除了热门大片，还有无数被埋没的冷门佳作等待发掘。555电影网编辑团队每月精选20部小众高分电影，带你领略不一样的电影世界。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20indie%20film%20abstract%20composition%20with%20soft%20moody%20lighting%2C%20warm%20amber%20and%20deep%20teal%20tones%2C%20film%20texture%20overlay%2C%20elegant%20minimalist%20background%2C%20thoughtful%20cinema%20aesthetic%2C%20refined%20atmosphere&width=900&height=500&seq=carousel-04&orientation=landscape',
    tag: '专题',
  },
  {
    title: '系列电影一网打尽',
    description: '从《速度与激情》到《哈利·波特》，从《指环王》到《复仇者联盟》，热门系列电影全集打包，让你一口气刷完整个系列，体验完整的叙事魅力。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20film%20series%20cinematic%20abstract%20art%20with%20dramatic%20warm%20lighting%2C%20multiple%20film%20frames%20overlay%2C%20golden%20amber%20tones%2C%20dark%20atmospheric%20background%2C%20powerful%20cinema%20aesthetic%2C%20elegant%20composition&width=900&height=500&seq=carousel-05&orientation=landscape',
    tag: '专题',
  },
];

export const RANKING_ITEMS = [
  { rank: 1, title: '《时空逆转2》', meta: '科幻 / 动作', score: '9.2', trend: 'up' },
  { rank: 2, title: '《暗夜追踪者》', meta: '悬疑 / 犯罪', score: '8.9', trend: 'up' },
  { rank: 3, title: '《夏日奇迹》', meta: '喜剧 / 家庭', score: '8.7', trend: 'new' },
  { rank: 4, title: '《深海迷踪》', meta: '冒险 / 科幻', score: '8.5', trend: 'down' },
  { rank: 5, title: '《城市之光》', meta: '剧情 / 文艺', score: '8.4', trend: 'up' },
];

export const COMMENTS_ITEMS = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20portrait%20silhouette%20with%20warm%20amber%20tones%2C%20minimalist%20style%2C%20soft%20gradient%20background%2C%20clean%20composition&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '影迷小陈',
    time: '2小时前',
    content: '555电影网的播放速度真的惊艳到我了，1080P高清画质居然一点都不卡，比某些需要会员的平台还流畅。片库也很全，想看的电影基本都能找到，强烈推荐！',
    movie: '《时空逆转2》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20portrait%20silhouette%20with%20soft%20peach%20tones%2C%20minimalist%20style%2C%20gentle%20gradient%20background%2C%20clean%20composition&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '电影达人李姐',
    time: '5小时前',
    content: '作为一个每天要看两三部电影的重度影迷，555电影网是我最常用的平台。更新快、片源全、不收费，这三个优点就足够让我每天打开它了。推荐给所有喜欢电影的朋友！',
    movie: '《暗夜追踪者》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20portrait%20silhouette%20with%20warm%20coral%20tones%2C%20minimalist%20style%2C%20soft%20gradient%20background%2C%20clean%20composition&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '老王看电影',
    time: '1天前',
    content: '以前总觉得免费电影网站画质差、广告多，555电影网完全颠覆了我的认知。界面干净整洁，播放流畅无广告，老片修复版的画质甚至比一些视频平台还好！',
    movie: '《城市之光》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20portrait%20silhouette%20with%20muted%20terracotta%20tones%2C%20minimalist%20style%2C%20soft%20gradient%20background%2C%20clean%20composition&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '周末影评人',
    time: '2天前',
    content: '作为业余影评人，我经常需要查阅大量电影资料。555电影网的分类导航做得很棒，按类型、年份、评分多维度筛选，找片效率非常高。高清修复的老片更是意外之喜。',
    movie: '《深海迷踪》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20portrait%20silhouette%20with%20warm%20sienna%20tones%2C%20minimalist%20style%2C%20soft%20gradient%20background%2C%20clean%20composition&width=80&height=80&seq=avatar-05&orientation=squarish',
    name: '学生党小明',
    time: '3天前',
    content: '学生党福音！不用花钱开会员就能看高清电影，宿舍WiFi都能流畅播放。片库更新也快，新出的电影没几天就能看到，室友都跟着我一起用555电影网了。',
    movie: '《夏日奇迹》',
  },
];

export const CARDS_ITEMS = [
  {
    title: '《时空逆转2》：年度科幻巨制的视觉革命',
    description: '导演以惊人的想象力构建了一个时间可逆的未来世界，每一帧都充满了令人窒息的视觉奇观。高清版已在555电影网独家上线。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20abstract%20cinematic%20scene%20with%20warm%20golden%20and%20amber%20light%20trails%2C%20time%20concept%20visual%2C%20soft%20bokeh%2C%20dark%20elegant%20background%2C%20sci-fi%20cinema%20aesthetic%2C%20refined%20artistic%20composition&width=800&height=450&seq=card-01&orientation=landscape',
    tag: '新片推荐',
  },
  {
    title: '暗夜追踪者：悬疑片的教科书级叙事',
    description: '一部让人从头猜到尾却永远猜不中的悬疑佳作，剧本精妙、表演炸裂，被誉为今年最值得二刷的悬疑电影。',
    image: 'https://readdy.ai/api/search-image?query=Noir%20mystery%20cinematic%20abstract%20art%20with%20deep%20shadows%20and%20warm%20amber%20streetlight%20glow%2C%20rainy%20atmosphere%2C%20soft%20textured%20background%2C%20elegant%20dark%20composition%2C%20suspenseful%20cinema%20aesthetic&width=800&height=450&seq=card-02&orientation=landscape',
    tag: '编辑精选',
  },
  {
    title: '暑期清凉片单：50部让你忘记炎热的大片',
    description: '从爆笑喜剧到惊险动作，从感人剧情到烧脑科幻，这份暑期片单覆盖全类型，承包你整个夏天的观影计划。',
    image: 'https://readdy.ai/api/search-image?query=Summer%20vibes%20cinematic%20abstract%20composition%20with%20warm%20sunset%20tones%2C%20golden%20light%20beams%2C%20soft%20dreamy%20atmosphere%2C%20elegant%20dark%20background%2C%20refreshing%20cinema%20aesthetic%2C%20artistic%20film%20texture&width=800&height=450&seq=card-03&orientation=landscape',
    tag: '专题合集',
  },
  {
    title: '国产电影黄金时代：近年十佳必看推荐',
    description: '中国电影正在经历前所未有的创作繁荣期，我们精选了十部代表作品，从不同维度展现国产电影的艺术成就与商业突破。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20artistic%20cinema%20abstract%20with%20warm%20red%20and%20golden%20tones%2C%20traditional%20brush%20stroke%20elements%2C%20soft%20elegant%20lighting%2C%20dark%20textured%20background%2C%20cultural%20film%20aesthetic%2C%20refined%20composition&width=800&height=450&seq=card-04&orientation=landscape',
    tag: '深度策划',
  },
  {
    title: '冷门佳片发掘计划：被忽视的影史遗珠',
    description: '在主流大片之外，还有无数值得一看的小众佳作。每月20部冷门高分推荐，打开电影审美的新世界大门。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20independent%20cinema%20abstract%20with%20soft%20moody%20warm%20lighting%2C%20film%20grain%20texture%2C%20amber%20and%20earth%20tones%2C%20elegant%20dark%20minimalist%20background%2C%20thoughtful%20aesthetic%2C%20refined%20composition&width=800&height=450&seq=card-05&orientation=landscape',
    tag: '冷门佳片',
  },
];